import { RootState } from '../index';
import { UserRole } from '../../types/UserInterface';

export const selectUser            = (state: RootState) => state.auth.user;
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const selectAuthLoading     = (state: RootState) => state.auth.loading;
export const selectAuthError       = (state: RootState) => state.auth.error;
export const selectUserRole        = (state: RootState) => state.auth.user?.role ?? null;

// ── Token selectors ───────────────────────────────────────────
export const selectLoginToken  = (state: RootState) => state.auth.loginToken;
export const selectTenantToken = (state: RootState) => state.auth.tenantToken;
export const selectApiKey      = (state: RootState) => state.auth.apiKey;

// ── Role selectors ────────────────────────────────────────────
export const selectHasRole = (role: UserRole) => (state: RootState): boolean =>
  state.auth.user?.role === role;

export const selectHasAnyRole = (...roles: UserRole[]) => (state: RootState): boolean =>
  roles.includes(state.auth.user?.role as UserRole);

const ROLE_HIERARCHY: Record<UserRole, number> = {
  Admin:   3,
  Manager: 2,
  Staff:   1,
};

export const selectHasMinimumRole = (minimumRole: UserRole) => (state: RootState): boolean => {
  const userRole = state.auth.user?.role;
  if (!userRole) return false;
  return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[minimumRole];
};